import { render } from "./InicioProveedores.vue?vue&type=template&id=4d8a9ed0"
import script from "./InicioProveedores.vue?vue&type=script&lang=js"
export * from "./InicioProveedores.vue?vue&type=script&lang=js"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__